require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./insights-the-inequitable-state-of-enterprise-and-investing.json") })
        }
      }, "path---insights-the-inequitable-state-of-enterprise-and-investing");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---insights-the-inequitable-state-of-enterprise-and-investing!./.cache/json/insights-the-inequitable-state-of-enterprise-and-investing.json
// module id = 1143
// module chunks = 231608221292675